import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67cb3ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Journaling" }
const _hoisted_2 = {
  key: 0,
  class: "content-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-container"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "flex-row-centered" }
const _hoisted_8 = { class: "flex-col-centered selection" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "owner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Owner:")
], -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { style: {"display":"grid","grid-template-columns":"max-content"} }
const _hoisted_14 = {
  title: "Enter exactly 1 journal reference to search",
  class: "centre-button-journal-reference"
}
const _hoisted_15 = ["disabled", "title"]
const _hoisted_16 = ["disabled", "title"]
const _hoisted_17 = ["title", "disabled"]
const _hoisted_18 = {
  key: 0,
  class: "highlight-green-bold"
}
const _hoisted_19 = {
  key: 1,
  class: "failure"
}

import {
    ref,
    Ref,
    onMounted,
    onBeforeUnmount,
    onBeforeMount,
    inject
} from "vue";
import { onBeforeRouteLeave } from "vue-router";
import router from "@/router";
// Services
import { apiLoggerKey } from "@/types/ServiceKeys";
import { authService } from "@/auth/authSingleton";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import { MarketSelection, financialSystemNetworkService } from "@/services/helpers/Helper";
import {
    cols,
    labels,
    ParseItems,
    JournalingServices,
    ICache,
} from "@/services/helpers/JournalingHelper";
// Data
import IJournalReportsItem from "@/interfaces/Journaling/IJournalingReportsItem";
import { journalingTypes, JournalingType, CanonicalToCamel } from "@/models/Journaling/JournalingTypes";
import { ISelection } from "@/Interfaces/ISelection";
import { IMetadata } from "@/interfaces/IMetadata";
import IJournalingBody from "@/Interfaces/Journaling/IJournalingBody";
import { marketSelection, ownerSelection } from "@/services/helpers/Helper";
import GroupedInputButton from "@/components/GroupedInputButton.vue";
// Table
import Table from "@/components/TablePersistentChecking.vue";
// Misc
import log from "loglevel";
import MarketSelector from "@/components/MarketSelector.vue";
import TitledSelection from "@/components/TitledSelection.vue";
import { RoutePaths } from "@/router/RouteDetails";
import MagnifyingGlass from "@/components/svg/MagnifyingGlass.vue";
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";
import { contractOwners as contractOwnersNetworkService } from "@/services/network";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const fileName = "Journaling.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Journaling',
  setup(__props) {

const cacheHolder = ref<ICache>();
const contractOwners = ref<ContractOwner[]>([]);
const unfilteredContractOwners = ref<ContractOwner[]>([]);
const page = ref(1);
const rowCount = ref(50);
const defaultSortCols = ref([0]);
const defaultSortOrders = ref<(1|-1)[]>([-1]);
const scrollPosition = ref(0);
const forcedIDs = ref('');
const journalReference = ref('')
const manualJNLButtonTitle = ref(DenyFunctionLevelAccess(FunctionAccessLevels.ManualJNL)? "You don't have the required permission level to perform this action." : "Insert Manual Journal")
const Logger = inject(apiLoggerKey);
const tableError = ref(false);
const proformaButtonDisabled = ref(false);
const exportButtonDisabled = ref(false);
const isLoading = ref(true);
const journalingReports = ref<IJournalReportsItem[]>();
const displayedJournalingReports = ref<IJournalReportsItem[]>();
const journalingServices: JournalingServices = new JournalingServices();
const lastProformaJobId= ref<number>();
const lastExportJobId = ref<number>();
const journalingTypeOptions: ISelection[] = journalingTypes.map((journalingType: JournalingType) => {
    return { text: journalingType.DisplayShort, val: journalingType.Canonical } as ISelection;
})
journalingTypeOptions.sort((a: ISelection, b: ISelection) =>
    a.text.localeCompare(b.text)
);
journalingTypeOptions.unshift({ text: "All", val: "" } as ISelection);
const journalingTypeSelection = ref('');
function journalingSelectionChanged(){
    if(journalingTypeSelection.value == ""){
        forcedIDs.value = ""
    }
}
const journalingRoutePath: string | undefined = router.options.routes
    .find((route) => route.name === 'Journaling Report')
    ?.path.split("/:")[0];
const previousPage: Ref<string | undefined> = ref(
    router.options.history.state.back?.toString()
);
const lastPage: Ref<string | undefined> = ref(
    router.options.history.state.forward?.toString()
);

log.trace("Journaling");

onBeforeUnmount(() => {
    log.trace("onBefoureUnmount() Journaling");
});
onBeforeRouteLeave((to, from, next) => {
    log.trace("onBeforeRouteLeave() Journaling");

    // If leaving to go to "Journaling Report", save journalingReports in session storage
    if (to.name === 'Journaling Report') {
        const cache: ICache = {
            Data: journalingReports.value!,
            Metadata: {
                Market: marketSelection.value,
                PageNumber: page.value,
                RowCount: rowCount.value,
                SortCols: defaultSortCols.value,
                SortOrders: defaultSortOrders.value,
                OwnerSelection: ownerSelection.value
            },
        };
        log.trace("onBeforeRouteLeave()\ncache", cache);
        sessionStorage.setItem("Journaling", JSON.stringify(cache));
    }
    next();
});
onBeforeMount(() => {
    log.trace("onBeforeMount() Journaling");
    if (
        lastPage.value?.startsWith(journalingRoutePath!) ||
        previousPage.value?.startsWith(journalingRoutePath!)
    ) {
        if ("Journaling" in sessionStorage) {
            log.debug("onBeforeMount() 'Journaling' in sessionStorage");
        }
    } else {
        log.debug("onBeforeMount() removing 'Journaling' from sessionStorage");
        sessionStorage.removeItem("Journaling");
    }
});
onMounted(async () => {
    log.trace("onMounted() Journaling");
    document.title = 'Journaling - UV';

    isLoading.value = true;
    if (!("Journaling" in sessionStorage)) {
        marketSelection.value = "GB";
        await GetContractOwners();
        await SetContractOwnerByMarket();
        await SetDefaultOwner();
    }
    else{
        cacheHolder.value = JSON.parse(sessionStorage.getItem("Journaling")!);
        marketSelection.value = cacheHolder.value?.Metadata.Market ?? "GB"
        await GetContractOwners();
        await SetContractOwnerByMarket();
    }    
    await GetJournalingReports().then(() => {
        sortJournalingReports();
    });
    
    isLoading.value = false;
});
async function GetContractOwners() {
    try {
        const res = (await contractOwnersNetworkService.get()).data
        
        unfilteredContractOwners.value = res;
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: "Contract Owners",
            error,
        });
    }
}

async function SetContractOwnerByMarket(){
    contractOwners.value = unfilteredContractOwners.value.filter( x => x.Market == marketSelection.value).sort((a, b) => {
                const aId = a?.OwnerId ?? "";
                const bId = b?.OwnerId ?? "";
                return bId.localeCompare(aId);
            }); 
}
async function SetDefaultOwner(){
    try{
        ownerSelection.value = contractOwners.value[0].OwnerId ?? "";
    }
    catch{
        console.warn("Contract owners were not loaded");
    }
}
async function GetJournalingReports(search?: boolean) {
    log.trace("GetJournalingReports()");

    const name = GetJournalingReports.name;
    const Class = fileName + "/" + name;

    if ("Journaling" in sessionStorage && search != true) {
        log.debug(
            "GetJournalingReports()\nLoading Journaling Reports from session storage"
        );

        const cache: ICache = cacheHolder.value ?? JSON.parse(sessionStorage.getItem("Journaling")!);
        const data: IJournalReportsItem[] = cache.Data;
        const metadata: IMetadata = cache.Metadata;
        // log.debug("GetJournalingReports()\nCACHE cache", cache);
        // log.debug("GetJournalingReports()\nCACHE data", data);

        journalingReports.value = data;
        displayedJournalingReports.value = journalingReports.value.map(ParseItems);

        marketSelection.value = (Object.keys(MarketSelection) as (keyof typeof MarketSelection)[]).find(
            m => m === metadata.Market
        ) ?? 'GB';
        ownerSelection.value = metadata.OwnerSelection!;
        scrollPosition.value = metadata.ScrollPosition!;
        page.value = metadata.PageNumber!;
        rowCount.value = metadata.RowCount!;
        defaultSortCols.value = metadata.SortCols!;
        defaultSortOrders.value = metadata.SortOrders!;
    } else {
        const urlParams: string =
            process.env.VUE_APP_JOURNALING_REPORTS_URL_PARAMS! +
            "?market=" +
            marketSelection.value +
            "&"+ "journalReference=" + journalReference.value +
            "&"+ "owner=" + ownerSelection.value;

        var Message = `Getting Journaling Reports: ${urlParams}`;

        log.debug(`${name}()\n${Message}`);
        try {
            resetErrors();
            const data = await journalingServices.getJournalingReports(urlParams);
            journalingReports.value = data;
            displayedJournalingReports.value = journalingReports.value.map(
                ParseItems
            );
            log.trace(
                "GetJournalingReports()\nAPI journalingReports",
                journalingReports.value
            );
            Logger?.LogInformation(Message, Class);
        } catch (error) {
            useNotifierWithErrFormatter().error({ errorType: 'Getting Journal Reports', error });
            tableError.value = true;
        }
    }
}

function redirectToManualJournal(){
    router.push({ path: RoutePaths["Create Manual Journal Entry"] });
}
async function updateMarketSelection() {
    sessionStorage.removeItem("Journaling")
    isLoading.value = true;
    await SetContractOwnerByMarket();
    await SetDefaultOwner();
    await GetJournalingReports();
    sortJournalingReports();
    isLoading.value = false;
}
function sortJournalingReports() {
    log.trace("sortJournalingReports()");

    displayedJournalingReports.value = displayedJournalingReports.value?.sort(
        (a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime()
    );
}
function resetErrors() {
    tableError.value = false;
}
async function RefreshJournalingTable() {
    isLoading.value = true;
    await GetJournalingReports(true).then(() => { sortJournalingReports()});
    isLoading.value = false;
}
async function ProformaJNL() {
    log.trace(ProformaJNL.name);

    const name = ProformaJNL.name;
    const Class = fileName + "/" + name;

    proformaButtonDisabled.value = true;
    resetErrors();

    lastProformaJobId.value = displayedJournalingReports.value
        ?.map((item: IJournalReportsItem) => Number(item.JobID))
        .sort((a, b) => b - a)
        .shift();
    log.debug("ProformaJNL()\nlastProformaJobId:", lastProformaJobId.value);

    log.debug("ProformaJNL() removing 'Journaling' from sessionStorage");
    sessionStorage.removeItem("Journaling");

    // log.debug("ProformaJNL()\nEmail Address:", authService.getEmailAddress());
    const body: IJournalingBody = {
        ExportJournal: false,
        UserName: authService.getEmailAddress(),
        Market: marketSelection.value,
        JournalType: journalingTypeSelection.value,
        ForcedIDs: forcedIDs.value, 
        OwnerID: ownerSelection.value
    };
    const urlParams: string = process.env.VUE_APP_PROFORMA_EXPORT_JOURNALING_URL_PARAMS!;

    isLoading.value = true;

    var Message = `Performing Proforma Journal, body: ${JSON.stringify(body)}`;

    log.debug(`name()\n${Message}`);
    await financialSystemNetworkService
        .post(body, urlParams)
        .then(async (response) => {
            log.debug("ProformaJNL() Response:", response);
            // Pull new data and load table
            
            await GetJournalingReports();
            sortJournalingReports();

            NoNewDataNotification(true);
            Logger?.LogInformation(Message, Class);
        })
        .catch((error) => {
            useNotifierWithErrFormatter().error({ errorType: 'Proforma Journal', error });
            Message = `(Error) ${Message}: ${error}`;
            log.error(Message);
            Logger?.LogError(Message, Class);
        })
        .finally(() => {
            isLoading.value = false;
            proformaButtonDisabled.value = false;
        });
}
async function ExportJNL() {
    sessionStorage.removeItem("Journaling");

    const name = ExportJNL.name;
    const Class = fileName + "/" + name;

    exportButtonDisabled.value = true;
    resetErrors();

    lastExportJobId.value = displayedJournalingReports.value
        ?.map((item: IJournalReportsItem) => Number(item.JobID))
        .sort((a, b) => b - a)
        .shift();
    log.debug("ExportJNL()\nlastExportJobId:", lastExportJobId.value);

    log.debug("ExportJNL() removing 'Journaling' from sessionStorage");
    sessionStorage.removeItem("Journaling");

    const body: IJournalingBody = {
        ExportJournal: true,
        UserName: authService.getEmailAddress(),
        Market: marketSelection.value,
        JournalType: journalingTypeSelection.value,
        ForcedIDs:forcedIDs.value, 
        OwnerID: ownerSelection.value
    };
    const urlParams: string = process.env.VUE_APP_PROFORMA_EXPORT_JOURNALING_URL_PARAMS!;

    isLoading.value = true;

    var Message = `Performing Export Journal, body: ${JSON.stringify(body)}`;

    log.debug(`name()\n${Message}`);
    await financialSystemNetworkService
        .post(body, urlParams)
        .then(async (response) => {
            log.debug("ExportJNL() Response:", response);
            // Pull new data and load table
            await GetJournalingReports();
            sortJournalingReports();
            NoNewDataNotification(false);
            Logger?.LogInformation(Message, Class);
        })
        .catch((error) => {
            useNotifierWithErrFormatter().error({ errorType: 'Export Journal', error });
            Message = `(Error) ${Message}: ${error}`;
            log.error(Message);
            Logger?.LogError(Message, Class);
        })
        .finally(() => {
            isLoading.value = false;
            exportButtonDisabled.value = false;
        });
}
function NoNewDataNotification(proforma: boolean) {
    if (proforma) {
        const latestProformaJobId = displayedJournalingReports.value
            ?.map((item: IJournalReportsItem) => Number(item.JobID))
            .sort((a, b) => b - a)
            .shift();

        log.debug(
            "NoNewDataNotification()\nlatestProformaJobId:",
            latestProformaJobId,
            "\nlastProformaJobId:",
            lastProformaJobId.value
        );
        if (latestProformaJobId === lastProformaJobId.value) 
        {    
            useNotifierWithErrFormatter().notify({msg: "No new data to perform Journaling."})
        }
    } else {
        const latestExportJobId = displayedJournalingReports.value
            ?.map((item: IJournalReportsItem) => Number(item.JobID))
            .sort((a, b) => b - a)
            .shift();

        log.debug(
            "NoNewDataNotification()\nlatestExportJobId:",
            latestExportJobId,
            "\nlastExportJobId:",
            lastExportJobId.value
        );
        if (latestExportJobId === lastExportJobId.value) {
            useNotifierWithErrFormatter().notify({msg: "No new data to perform Journaling."})
        }
    }
}
function RowClicked(row: IJournalReportsItem) {
    log.trace(RowClicked.name);
    const r = {
        name: 'Journaling Report',
        params: {
            id: row.JobID,
        },
        query: {
            JournalType: row.JournalType,
            Status: row.Status,
        },
    };
    // Open in current tab
    router.push(r);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(MarketSelector, {
                onChange: updateMarketSelection,
                enableSE: "",
                shortTitle: ""
              }),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(ownerSelection) ? (ownerSelection).value = $event : null)),
                  class: "dropdown",
                  required: "",
                  id: "owner",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (RefreshJournalingTable()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractOwners.value, (contractOwner) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: contractOwner.OwnerId,
                      key: contractOwner.OwnerId
                    }, _toDisplayString(contractOwner.FullName), 9, _hoisted_10))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _unref(ownerSelection)]
                ])
              ]),
              _createVNode(TitledSelection, {
                title: "Journal Type Selection:",
                for: "journalTypeSelect"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "journalTypeSelect",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((journalingTypeSelection).value = $event)),
                    class: "dropdown",
                    style: {"width":"16rem"},
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (journalingSelectionChanged()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(journalingTypeOptions), (journalingType) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: journalingType.val,
                        key: journalingType.val
                      }, _toDisplayString(journalingType.text), 9, _hoisted_11))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, journalingTypeSelection.value]
                  ])
                ]),
                _: 1
              }),
              (journalingTypeSelection.value !='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(TitledSelection, {
                      for: "forced-ids",
                      title: `Enter IDs to force journal:`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((forcedIDs).value = $event)),
                            id: "forced-ids",
                            type: "text",
                            placeholder: "Enter IDs...",
                            style: {"grid-column":"1","grid-row":"1","width":"100%"}
                          }, null, 512), [
                            [_vModelText, forcedIDs.value]
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(TitledSelection, {
                for: "journal-ref-id",
                title: "Search for Journal Reference:"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    id: "journal-ref",
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {GetJournalingReports(true);}, ["prevent"]))
                  }, [
                    _createVNode(GroupedInputButton, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "journal-ref-id",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((journalReference).value = $event)),
                          class: "selection-form-input",
                          type: "text",
                          placeholder: "Enter Journal Reference...",
                          pattern: ".*\\S+.*"
                        }, null, 512), [
                          [_vModelText, journalReference.value]
                        ]),
                        _createElementVNode("button", _hoisted_14, [
                          _createVNode(MagnifyingGlass, {
                            class: "selection-form-btn",
                            style: {"width":"20px"}
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ], 32)
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (ProformaJNL())),
                class: "centre-button",
                disabled: tableError.value ||
                        proformaButtonDisabled.value ||
                        _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).ProformaJNL)
                        ,
                title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).ProformaJNL) ? 'Proforma Journal (Access denied)' : 'Proforma Journal'
              }, " Proforma JNL ", 8, _hoisted_15),
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (ExportJNL())),
                class: "centre-button",
                disabled: tableError.value ||
                        exportButtonDisabled.value ||
                        _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).ExportJNL)
                        ,
                title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).ExportJNL) ? 'Export Journal (Access denied)' : 'Export Journal'
              }, " Export JNL ", 8, _hoisted_16),
              _createElementVNode("button", {
                onClick: redirectToManualJournal,
                class: "centre-button",
                title: manualJNLButtonTitle.value,
                disabled: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).ManualJNL)
              }, " Manual JNL ", 8, _hoisted_17)
            ])
          ]),
          _createVNode(Table, {
            Rows: displayedJournalingReports.value,
            Cols: _unref(cols),
            Labels: _unref(labels),
            RowClickedCallBack: RowClicked,
            DefaultSortCols: defaultSortCols.value,
            DefaultSortOrders: defaultSortOrders.value,
            HasError: tableError.value,
            Page: page.value,
            "onUpdate:Page": _cache[9] || (_cache[9] = ($event: any) => ((page).value = $event)),
            RowsPerPage: rowCount.value,
            "onUpdate:RowsPerPage": _cache[10] || (_cache[10] = ($event: any) => ((rowCount).value = $event))
          }, {
            Status: _withCtx((props) => [
              (props.value.Status === 'SUCCESS')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(props.value.Status), 1))
                : _createCommentVNode("", true),
              (props.value.Status === 'FAILURE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(props.value.Status), 1))
                : _createCommentVNode("", true)
            ]),
            JournalType: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_unref(CanonicalToCamel)(props.value.JournalType)), 1)
            ]),
            _: 1
          }, 8, ["Rows", "Cols", "Labels", "DefaultSortCols", "DefaultSortOrders", "HasError", "Page", "RowsPerPage"])
        ]))
  ]))
}
}

})